import { Injectable } from '@angular/core';
import { ConfigurationModel, ServerParameterModel } from '../_models/_index';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';

@Injectable()
export class RequestManagementService {

    private baseUrl: string;
    private baseUrlPromise: Promise<boolean>;
    private configUrl: string = 'assets/config.json';

    constructor(private http: Http) {
       
    }

    public loadConfiguration(): Promise<boolean> {
        if (!this.baseUrlPromise) {
            this.baseUrlPromise = this.getConfig()
                .then(data => {
                    this.baseUrl = data.webApiUrl;
                    return this.baseUrl != undefined;
                });
        }
        return this.baseUrlPromise;
    }

    getConfig() {
        return this.http.get(this.configUrl).map((response: Response) => {
            return <ConfigurationModel>response.json();
        }).toPromise();
    }

    getBaseUrl()
    {
        return this.baseUrl;
    }

    callGetRequest(methodName: string, listParams: any): Observable<any> {
        return this.http.get(this.baseUrl + methodName, {
            params: listParams,
        });
    }

    callGetRequestFile(methodName: string, listParams: any): Observable<any> {
        
        return this.http.get(this.baseUrl + methodName, {
            params: listParams
        });
    }


    //callGetRequest(methodName: string, ...parameters: ServerParameterModel[]): Observable<Response> {
    //    let options = null;
    //    if (parameters != null) {
    //        parameters.forEach(parameter => {
    //            let params: URLSearchParams = new URLSearchParams();
    //            params.set(parameter.parameterName, parameter.parameterValue);
    //            params.set(parameter.parameterName, parameter.parameterValue);

    //            let headers = new Headers({ 'Content-Type': 'application/json' });
    //            options = new RequestOptions({
    //                headers: headers,
    //                search: params
    //            });
    //        });
    //    }
    //    return this.http.get(this.baseUrl + methodName, options);
    //}

    callPostRequest(methodName: string, obj: any): Observable<Response> {
        return this.http.post(this.baseUrl + methodName, obj);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/request-management.service.ts